module.exports = __webpack_public_path__ + "img/b3d06df3e8337d77f59e0c7ed54d3b8c.svg";